import React from 'react';
import { Route, Redirect } from 'react-router';

import App from 'modules/App/containers/App';

import homeRoutes from 'modules/Home/routes';
import footballRoutes from 'modules/Football/routes';
import horseRacingRoutes from 'modules/HorseRacing/routes';
import greyhoundRacingRoutes from 'modules/GreyhoundRacing/routes';
import cricketRoutes from 'modules/Cricket/routes';
import dartsRoutes from 'modules/Darts/routes';
import golfRoutes from 'modules/Golf/routes';
import rugbyLeagueRoutes from 'modules/RugbyLeague/routes';
import rugbyUnionRoutes from 'modules/RugbyUnion/routes';
import tennisRoutes from 'modules/Tennis/routes';
import boxingRoutes from 'modules/Boxing/routes';
import formulaOneRoutes from 'modules/FormulaOne/routes';
import snookerRoutes from 'modules/Snooker/routes';
import nflRoutes from 'modules/NFL/routes';
import otherSportsRoutes from 'modules/OtherSports/routes';

import errorRoutes from 'modules/Errors/routes';
import newsRoutes from 'modules/News/routes';
import insiderRoutes from 'modules/Insider/routes';
import privacyRoutes from 'modules/PrivacyPolicy/routes'

export default function Routes() {
  return (
    <Route path="/" component={App} >
      {homeRoutes}
      {footballRoutes}
      {horseRacingRoutes}
      {greyhoundRacingRoutes}
      {cricketRoutes}
      {dartsRoutes}
      {golfRoutes}
      {rugbyLeagueRoutes}
      {rugbyUnionRoutes}
      {tennisRoutes}
      {boxingRoutes}
      {formulaOneRoutes}
      {snookerRoutes}
      {nflRoutes}
      {otherSportsRoutes}
      {errorRoutes}
      {newsRoutes}
      {insiderRoutes}
      {privacyRoutes}
      <Redirect from="*" to="/error/404/*"/>
    </Route>
  );
}



// WEBPACK FOOTER //
// ./routes.js